module.exports = __webpack_public_path__ + "img/newzealand.871bbee9.png";